/**
 * Compromisso de entrega na PDP — janela de datas, countdown e região via IP.
 */
(function (global) {
  'use strict';

  var CACHE_KEY = 'belabelly_pdp_geo_v1';
  var CACHE_TTL_MS = 24 * 60 * 60 * 1000;
  var MONTHS = ['jan.', 'fev.', 'mar.', 'abr.', 'mai.', 'jun.', 'jul.', 'ago.', 'set.', 'out.', 'nov.', 'dez.'];

  var TRANSIT_BY_UF = {
    SC: 2,
    RS: 3,
    PR: 3,
    SP: 4,
    RJ: 5,
    MG: 5,
    ES: 5,
    GO: 6,
    DF: 6,
    MS: 7,
    MT: 7,
    BA: 8,
    SE: 9,
    AL: 9,
    PE: 9,
    PB: 9,
    RN: 9,
    CE: 9,
    PI: 10,
    MA: 10,
    PA: 10,
    AM: 11,
    AP: 11,
    RR: 11,
    RO: 10,
    AC: 11,
    TO: 9,
  };

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.at || Date.now() - parsed.at > CACHE_TTL_MS) return null;
      return parsed.data || null;
    } catch (err) {
      return null;
    }
  }

  function writeCache(data) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), data: data }));
    } catch (err) {
      /* ok */
    }
  }

  function normalizeUf(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .slice(0, 2);
  }

  function transitDaysForUf(uf) {
    if (!uf) return 0;
    return TRANSIT_BY_UF[uf] != null ? TRANSIT_BY_UF[uf] : 8;
  }

  function parsePayload(payload) {
    if (!payload || typeof payload !== 'object') return null;
    var country = normalizeUf(payload.country_code || payload.countryCode || payload.country);
    if (country && country !== 'BR') {
      return { country: country, uf: '', isBrazil: false };
    }
    var uf = normalizeUf(payload.region_code || payload.regionCode || payload.region);
    return { country: 'BR', uf: uf, isBrazil: true };
  }

  function fetchGeo() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);

    return fetch('https://ipwho.is/', { credentials: 'omit' })
      .then(function (res) {
        if (!res.ok) throw new Error('geo');
        return res.json();
      })
      .then(function (json) {
        if (json && json.success === false) throw new Error('geo');
        var geo = parsePayload(json);
        if (geo) writeCache(geo);
        return geo;
      })
      .catch(function () {
        return fetch('https://ipapi.co/json/', { credentials: 'omit' })
          .then(function (res) {
            if (!res.ok) throw new Error('geo');
            return res.json();
          })
          .then(function (json) {
            var geo = parsePayload(json);
            if (geo) writeCache(geo);
            return geo;
          });
      })
      .catch(function () {
        return null;
      });
  }

  function scheduleGeoFetch(callback) {
    var run = function () {
      fetchGeo().then(callback);
    };
    if (typeof global.requestIdleCallback === 'function') {
      global.requestIdleCallback(run, { timeout: 2500 });
    } else {
      global.setTimeout(run, 1200);
    }
  }

  function isProntaEntregaActive(el) {
    var pdp = el.closest('[data-md-pdp]');
    if (!pdp) return false;
    var meta = pdp.querySelector('[data-md-stock]');
    if (!meta || !meta.hasAttribute('data-production-full')) return false;
    return meta.classList.contains('md-pdp__meta--in-stock');
  }

  function fallbackTotalDays(el) {
    var productionDays = Number(el.dataset.productionDays) || 4;
    var fallbackShippingDays = Number(el.dataset.fallbackShippingDays) || 5;
    var prontaDispatchDays = Number(el.dataset.prontaEntregaDispatchDays) || 2;

    if (el.dataset.prontaEntrega === 'true' && isProntaEntregaActive(el)) {
      return prontaDispatchDays + fallbackShippingDays;
    }

    return productionDays + fallbackShippingDays;
  }

  function isGeoResolved(geo) {
    return !!(geo && geo.isBrazil && geo.uf);
  }

  function computeTotalDays(el, geo) {
    if (!isGeoResolved(geo)) {
      return fallbackTotalDays(el);
    }

    var productionDays = Number(el.dataset.productionDays) || 0;
    var dispatchDays = Number(el.dataset.dispatchDays) || 1;
    var prontaDispatchDays = Number(el.dataset.prontaEntregaDispatchDays) || 2;

    if (el.dataset.prontaEntrega === 'true' && isProntaEntregaActive(el)) {
      return prontaDispatchDays + transitDaysForUf(geo.uf);
    }

    return productionDays + dispatchDays + transitDaysForUf(geo.uf);
  }

  function addBusinessDays(from, days) {
    var d = new Date(from.getTime());
    var left = Math.max(0, days);
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  }

  function formatPtDate(date) {
    var day = date.getDate();
    var month = MONTHS[date.getMonth()] || '';
    return day + ' de ' + month;
  }

  function cutoffMs(now) {
    var end = new Date(now.getTime());
    end.setHours(23, 59, 59, 999);
    if (end.getTime() <= now.getTime()) {
      end.setDate(end.getDate() + 1);
    }
    return end.getTime() - now.getTime();
  }

  function formatRemain(ms) {
    var totalMin = Math.max(0, Math.floor(ms / 60000));
    var h = Math.floor(totalMin / 60);
    var m = totalMin % 60;
    return h + 'h ' + m + 'min';
  }

  function productQualifies(el) {
    if (el.dataset.qualifiesFreeShipping === 'true') return true;
    var pdp = el.closest('[data-md-pdp]');
    if (!pdp) return false;
    var price = Number(pdp.dataset.variantPrice || 0);
    var pixPct = Number(pdp.dataset.pixDiscount || 5) / 100;
    var min = Number(el.dataset.freeShippingMin || pdp.dataset.freeShippingMin || 29900);
    return Math.round(price * (1 - pixPct)) >= min;
  }

  function renderTitle(el, geo) {
    var now = new Date();
    var days = computeTotalDays(el, geo);
    var extra = Number(el.dataset.windowExtraDays) || 5;
    var start = addBusinessDays(now, days);
    var end = addBusinessDays(now, days + extra);
    var startLabel = formatPtDate(start);
    var endLabel = formatPtDate(end);
    var titleEl = el.querySelector('[data-md-delivery-title]');
    if (!titleEl) return;
    var tpl = productQualifies(el)
      ? el.dataset.templateArriveFree
      : el.dataset.templateArriveFrom;
    tpl = tpl || 'Chegará entre __START__ e __END__.';
    titleEl.textContent = tpl.replace(/__START__/g, startLabel).replace(/__END__/g, endLabel);
  }

  function renderCountdown(el) {
    var node = el.querySelector('[data-md-delivery-countdown]');
    if (!node) return;
    var tpl = el.dataset.templateBuyWithin || 'Comprando dentro das próximas __TIME__.';
    node.textContent = tpl.replace(/__TIME__/g, formatRemain(cutoffMs(new Date())));
  }

  function render(el, geo) {
    renderTitle(el, geo);
    renderCountdown(el);
    el.hidden = false;
    el.classList.add('is-ready');
    el.removeAttribute('aria-busy');
  }

  function initEl(el) {
    if (el.dataset.mdDeliveryEstimateInit === 'true') return;
    el.dataset.mdDeliveryEstimateInit = 'true';

    var pdp = el.closest('[data-md-pdp]');
    var stockMeta = pdp ? pdp.querySelector('[data-md-stock]') : null;
    var cached = readCache();

    function refreshFromCacheOrFallback() {
      render(el, cached || null);
    }

    refreshFromCacheOrFallback();

    if (!cached) {
      scheduleGeoFetch(function (geo) {
        if (geo) {
          cached = geo;
          render(el, geo);
        }
      });
    }

    if (stockMeta && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(refreshFromCacheOrFallback);
      observer.observe(stockMeta, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }

    if (!global.__belabellyDeliveryInfoBound) {
      global.__belabellyDeliveryInfoBound = true;
      document.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-md-delivery-info]');
        var wraps = document.querySelectorAll('.md-pdp__delivery-card__info-wrap');
        if (!btn) {
          wraps.forEach(function (wrap) {
            wrap.classList.remove('is-open');
            var infoBtn = wrap.querySelector('[data-md-delivery-info]');
            if (infoBtn) infoBtn.setAttribute('aria-expanded', 'false');
          });
          return;
        }
        event.preventDefault();
        var wrap = btn.closest('.md-pdp__delivery-card__info-wrap');
        var willOpen = wrap && !wrap.classList.contains('is-open');
        wraps.forEach(function (node) {
          node.classList.remove('is-open');
          var infoBtn = node.querySelector('[data-md-delivery-info]');
          if (infoBtn) infoBtn.setAttribute('aria-expanded', 'false');
        });
        if (wrap && willOpen) {
          wrap.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (!global.__belabellyDeliveryCountdown) {
      global.__belabellyDeliveryCountdown = setInterval(function () {
        document.querySelectorAll('[data-md-delivery-estimate]').forEach(renderCountdown);
      }, 30000);
    }
  }

  function initRoot(root) {
    if (!root) return;
    root.querySelectorAll('[data-md-delivery-estimate]').forEach(initEl);
  }

  function init() {
    initRoot(document);
  }

  global.BelabellyPdpDeliveryEstimate = {
    init: init,
    initRoot: initRoot,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window);
